import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { connect } from "formik";
import { compose } from "redux";
import { MoneyInput, TextInput, AutoCompleteInput, PercentInput, IntegerInput } from "components/Global/FormikMaterial";

import { INTEREST_ONLY, MORTGAGE_STYLE, STRAIGHT_LINE, STRAIGHT_LINE_CUSTOM_AMOUNT, AGENCY_FLOATER } from "../Constants/AmortizationType";
import { FIXED_RATE } from "../Constants/InterestRateType";
import {
  amortTypes
} from "../Constants/DropDownLists";

import FormSectionTitle from "./FormSectionTitle";

const StyledAutoCompleteInput = styled(AutoCompleteInput)`
  & {
    width:100%;
  }
`;
const StyledMoneyInput = styled(MoneyInput)`
  & {
    width:100%;
  }
`;

const StyledIntegerInput = styled(IntegerInput)`
  & {
    width:100%;
  }
`;
const StyledPercentInput = styled(PercentInput)`
  & {
    width:100%;
  }
`;
const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
 }`;
function shouldHideAmortizationRate(amortizationType, interestRateType) {
  return !amortizationType ||
          amortizationType === INTEREST_ONLY ||
          amortizationType === STRAIGHT_LINE ||
          amortizationType === STRAIGHT_LINE_CUSTOM_AMOUNT ||
          amortizationType === AGENCY_FLOATER ||
          (interestRateType === FIXED_RATE && amortizationType === MORTGAGE_STYLE);
}
function shouldHideAmortizationTerm(amortizationType) {
  return !amortizationType ||
          amortizationType === INTEREST_ONLY ||
          amortizationType === STRAIGHT_LINE_CUSTOM_AMOUNT;
}
function shouldHideCustomMonthlyPrincipalReduction(amortizationType) {
  return !amortizationType ||
         amortizationType === INTEREST_ONLY ||
         amortizationType === STRAIGHT_LINE ||
         amortizationType === MORTGAGE_STYLE ||
         amortizationType === AGENCY_FLOATER;
}
function shouldHideIoPeriod(amortizationType) {
  return !amortizationType ||
         amortizationType === INTEREST_ONLY;
}

function getMorgageStyleColSize(amortizationType) {
  return amortizationType === MORTGAGE_STYLE ? 3 : 5;
}

const AmortizationFormSection = ({ formik }) => {
  const { values } = formik;

  return (
    <>
      <Grid item xs={12}>
        <FormSectionTitle title="Amortization" />
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
        <StyledAutoCompleteInput
          label={<StyledLabel>{"Amort Type"}</StyledLabel>}
          fieldName="amortizationType"
          selectValue="value"
          options={amortTypes}
        />
      </Grid>
      <Grid item xs={2} sm={2} md={2} lg={2} xl={2} hidden={shouldHideAmortizationRate(values.amortizationType, values.interestRateType)}>
        <StyledPercentInput
          label={<StyledLabel>{"Amort Rate%"}</StyledLabel>}
          decimalScale={3}
          fieldName="amortizationRate"
          allowNegative={false}
        />
      </Grid>
      <Grid item xs={getMorgageStyleColSize(values.amortizationType)} sm={getMorgageStyleColSize(values.amortizationType)} md={getMorgageStyleColSize(values.amortizationType)} lg={getMorgageStyleColSize(values.amortizationType)} xl={getMorgageStyleColSize(values.amortizationType)} hidden={shouldHideAmortizationTerm(values.amortizationType)}>
        <StyledIntegerInput
          label={<StyledLabel>{"Amort Term(m)"}</StyledLabel>}
          fieldName="amortizationTerm"
        />
      </Grid>
      <Grid item xs={5} hidden={shouldHideCustomMonthlyPrincipalReduction(values.amortizationType)}>
        <StyledMoneyInput
          label={<StyledLabel>{"Monthly Reduction"}</StyledLabel>}
          fieldName="customMonthlyPrincipalReduction"
        />
      </Grid>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3} hidden={shouldHideIoPeriod(values.amortizationType)}>
        <StyledIntegerInput
          label={<StyledLabel>{"I/O Period(m)"}</StyledLabel>}
          fieldName="interestOnlyPeriod"
        />
      </Grid>
    </>
  );
};
export default compose(
  connect
)(AmortizationFormSection);
